import React, { useState, useEffect } from 'react'

import { P } from '../../../../../style/Typography.style'

import Flex from '../../../../../components/layouts/Flex'
import DashboardInput from '../../../../../components/dashboard/DashboardInput'

import { SingleSelect } from '../../../../../components/SelectDropdown'
import RichTextbox from '../../../../../components/dashboard/controls/RichTextBox'
import DashboardPhoneInput from '../../../../../components/dashboard/DashboardPhoneInput'

import countries from 'all-countries-and-cities-json'

const PersonalInformation = ({ onChange, details, fieldErrors }) => {
  const [countryList, setCountryList] = useState([])
  const [cityList, setCityList] = useState([])

  const handleChange = (name, value) => {
    onChange({ [name]: value })
  }

  useEffect(() => {
    // Countries and Cities from local JSON
    const countryNames = Object.keys(countries).map((country) => ({
      value: country,
      label: country,
    }))
    setCountryList(countryNames)
    handleChange('country', details?.country || countryNames[0])

    const cityNames = Object.keys(countries).reduce((acc, country) => {
      const cities = countries[country] || []
      const formattedCities = cities.map((city) => ({
        value: city,
        label: city,
      }))
      return [...acc, ...formattedCities]
    }, [])
    setCityList(cityNames)
    handleChange('city', details?.city || cityNames[0])
  }, [])

  const handleCountryChange = (e) => {
    handleChange('country', e)
    const selectedCountry = e.value
    const cities = countries[selectedCountry] || []
    const formattedCities = cities.map((city) => ({
      value: city,
      label: city,
    }))
    setCityList(formattedCities)
    handleChange('city', formattedCities[0])
  }

  return (
    <>
      <Flex gap="1rem">
        <DashboardInput
          errorMessage={fieldErrors?.firstName}
          name="firstName"
          label="First Name *"
          placeholder="Enter First Name"
          type="text"
          height="2.5rem"
          value={details?.firstName}
          handleChange={(e) => handleChange('firstName', e.target.value)}
        />
        <DashboardInput
          errorMessage={fieldErrors?.middleName}
          name="middleName"
          label="Middle Name *"
          placeholder="Enter Middle Name"
          type="text"
          height="2.5rem"
          value={details?.middleName}
          handleChange={(e) => handleChange('middleName', e.target.value)}
        />
        <DashboardInput
          errorMessage={fieldErrors?.lastName}
          name="lastName"
          label="Last Name *"
          placeholder="Enter Last Name"
          type="text"
          height="2.5rem"
          value={details?.lastName}
          handleChange={(e) => handleChange('lastName', e.target.value)}
        />
      </Flex>

      <P>Professional Summary</P>

      <RichTextbox
        content={details?.professionalSummary}
        setContent={(value) => handleChange('professionalSummary', value)}
      />

      <DashboardPhoneInput
        errorMessage={fieldErrors?.contactNumber}
        name="phoneNumber"
        label="Contact Number"
        placeholder=""
        type="text"
        height="2.5rem"
        value={details?.contactNumber}
        handleChange={(e) => handleChange('contactNumber', e)}
      />

      <Flex gap="1rem" margin="0 0 0.5rem 0">
        <SingleSelect
          title="Country"
          options={countryList}
          selected={details?.country}
          placeholder="Select Country"
          // onChange={(e) => handleChange('country', e)}
          onChange={handleCountryChange}
          wrapperClass={fieldErrors?.country && 'error'}
          subText={fieldErrors?.country}
        />

        <SingleSelect
          title="City"
          options={cityList}
          selected={details?.city}
          placeholder="Select City"
          onChange={(e) => handleChange('city', e)}
          wrapperClass={fieldErrors?.city && 'error'}
          subText={fieldErrors?.city}
        />
      </Flex>

      <Flex gap="1rem">
        <DashboardInput
          errorMessage={fieldErrors?.address}
          name="address"
          label="Address *"
          placeholder="Enter Address"
          type="text"
          height="2.5rem"
          value={details?.address}
          handleChange={(e) => handleChange('address', e.target.value)}
        />
        <DashboardInput
          errorMessage={fieldErrors?.zipCode}
          name="zipCode"
          label="Zip Code *"
          placeholder="Enter Zip Code"
          type="text"
          height="2.5rem"
          value={details?.zipCode}
          handleChange={(e) => handleChange('zipCode', e.target.value)}
        />
      </Flex>
    </>
  )
}

export default PersonalInformation
